import { createAction } from '@reduxjs/toolkit';

import { SortOptions } from 'constants/sorting';

import { SortingState } from './state';

export const setSorting = createAction<{ option: SortOptions; key: SortingState[SortOptions] }>('sorting/setSorting');
